import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { projectsAPI } from '../api';
import './MyBackedProjects.css';

function MyBackedProjects() {
  const [backedProjects, setBackedProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadBackedProjects();
  }, []);

  const loadBackedProjects = async () => {
    try {
      const response = await projectsAPI.getMyBackedProjects();
      if (response.data.success) {
        setBackedProjects(response.data.backed_projects);
      }
    } catch (error) {
      console.error('Error loading backed projects:', error);
      setError('Failed to load backed projects');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="my-backed-projects">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading your backed projects...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="my-backed-projects">
        <div className="error-state">
          <h2>Error</h2>
          <p className="text-muted">{error}</p>
          <button onClick={loadBackedProjects} className="btn btn-primary">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="my-backed-projects">
      <div className="page-header">
        <h1 className="page-title">
          ❤️ Projects I'm Backing
          <span className="badge-count">{backedProjects.length}</span>
        </h1>
        <p className="text-muted">
          Support your favorite projects and get updates from creators
        </p>
      </div>

      {backedProjects.length === 0 ? (
        <div className="empty-state card">
          <div className="empty-icon">❤️</div>
          <h3>No backed projects yet</h3>
          <p className="text-muted">
            Start supporting amazing projects by backing them on their public pages
          </p>
          <Link to="/browse" className="btn btn-primary mt-3">
            Browse Projects
          </Link>
        </div>
      ) : (
        <div className="backed-projects-grid">
          {backedProjects.map(({ backing, project }) => (
            <div key={project.project_id} className="backed-project-card card">
              <div className="backed-project-header">
                <div className="project-icon-small">
                  {project.title.charAt(0).toUpperCase()}
                </div>
                <div className="backed-project-info">
                  <h3 className="backed-project-title">
                    <Link to={`/p/${project.slug}`}>
                      {project.title}
                    </Link>
                  </h3>
                  <p className="backed-project-owner">
                    by {project.owner}
                  </p>
                </div>
              </div>

              {project.thumbnail && (
                <div className="backed-project-thumbnail">
                  <img src={project.thumbnail} alt={project.title} />
                </div>
              )}

              {project.short_description && (
                <p className="backed-project-description">
                  {project.short_description}
                </p>
              )}

              <div className="backing-details">
                <div className="backing-detail-row">
                  <span className="backing-detail-label">Tier:</span>
                  <span className={`backer-tier tier-${backing.tier}`}>
                    {backing.tier}
                  </span>
                </div>

                <div className="backing-detail-row">
                  <span className="backing-detail-label">Since:</span>
                  <span className="backing-detail-value">
                    {new Date(backing.created_at).toLocaleDateString('en-US', {
                      month: 'long',
                      year: 'numeric'
                    })}
                  </span>
                </div>

                {backing.message && (
                  <div className="backing-message-box">
                    <strong>My message:</strong>
                    <p className="backing-message">"{backing.message}"</p>
                  </div>
                )}

                {backing.is_public === false && (
                  <div className="backing-privacy">
                    <span className="badge-private">🔒 Private</span>
                  </div>
                )}
              </div>

              <div className="backed-project-actions">
                <Link 
                  to={`/p/${project.slug}`}
                  className="btn btn-primary btn-block"
                >
                  View Project
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MyBackedProjects;
